import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import autobind from 'autobind-decorator'

class TTextareaForm extends Component {

	constructor(props, context) {
		super(props, context)
		this.state = {
			focus: false,
		}

		this.value = props.defaultValue
	}

	componentDidMount() {
		const { focus } = this.props
		const { input } = this.refs
		if (focus) {
			input.focus()
		}
	}

	@autobind
	handleChange(e) {
		const { onChange } = this.props
		const { input } = this.refs
		this.value = input.value

		if (onChange) {
			onChange(input.value)
		}
	}

	@autobind
	handleFocus() {
		this.setState({
			focus: true
		})
	}

	@autobind
	handleBlur() {
		this.setState({
			focus: false
		})
	}

	focus() {
		const { input } = this.refs
		input.focus()
	}

	render() {
		const { className, defaultValue, placeholder, value } = this.props;
		const { focus } = this.state

		return (
			<textarea ref="input" className={classnames(className, { "tf_on": focus })} defaultValue={defaultValue} value={value} placeholder={placeholder}
				   onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur} />
		)
	}
}

TTextareaForm.propTypes = {
	className: PropTypes.string,
	defaultValue: PropTypes.string,
	placeholder: PropTypes.string
}

export default TTextareaForm
